package kz.dentalcrm.app.data.network.response_model

import kotlinx.serialization.Serializable

@Serializable
data class PatientPivot(
    val organization_id: Int?,
    val patient_id: Int?
)